import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AuthHeader from './AuthHeader';
import { useSelector } from 'react-redux';
import SystemService from '@/services/SystemService';
import ToastMe from '@/components/ui/ToastMe';

function AuthLayout() {
    const { generalSetting } = useSelector((state) => state?.GeneralSetting);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Temporarily disabled activation check
        // let cancelled = false;

        // async function ensureActivated() {
        //     try {
        //         const status = await SystemService.fetchLicenseStatus();
        //         if (cancelled) return;

        //         const needsActivation =
        //             status?.enforce &&
        //             (!status?.cacheValid || status?.locked || status?.status !== 'ok');

        //         if (needsActivation && location.pathname !== '/activate') {
        //             ToastMe('System activation required before signing in.', 'warning');
        //             navigate('/activate', { replace: true });
        //         }
        //     } catch (err) {
        //         if (cancelled) return;
        //         console.warn('[AuthLayout] license status check failed:', err);
        //     }
        // }

        // ensureActivated();
        // return () => {
        //     cancelled = true;
        // };
    }, [location.pathname, navigate]);

    return (
        <>
            <AuthHeader title={generalSetting?.company_name} faviconIcon={generalSetting?.fav_icon}/>
            <Outlet />
        </>
    );
}

export default AuthLayout;
